import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { ItemState } from './items.reducer'
import * as ItemsSelectors from './items.selectors'
import * as ItemActions from './items.actions'
import { ObjectUtils } from 'libs/shared/utils/helpers/src'
import { Params } from '@angular/router'
import { of, switchMap } from 'rxjs'

/**
 * item service that gets data from the API as well as from the state
 */
@Injectable({
  providedIn: 'root',
})
export class ItemFacade implements GbBaseFacade {
  items$ = this.store.select(ItemsSelectors.selectAllListLoadedItems)
  filteredItems$ = this.store.select(ItemsSelectors.selectFilteredItems)
  filteredItemIds$ = this.store.select(ItemsSelectors.selectFilteredItemsIds)
  count$ = this.store.select(ItemsSelectors.selectItemCount)
  order$ = this.store.select(ItemsSelectors.selectItemOrder)
  currentFilters$ = this.store.select(ItemsSelectors.selectCurrentFilters)
  currentError$ = this.store.select(ItemsSelectors.selectErrorMessage)
  showPoppers$ = this.store.select(ItemsSelectors.selectShowPoppers)
  stale$ = this.store.select(ItemsSelectors.selectStaleState)
  stalePages$ = this.store.select(ItemsSelectors.selectStalePages)
  staleFilteredPages$ = this.store.select(ItemsSelectors.selectStaleFilteredPages)
  hasBidItems$ = this.store.select(ItemsSelectors.selectHasBidItems)
  selectItemById$ = (id: string, checkFiltered = false) =>
    this.store.select(ItemsSelectors.selectItemById(id)).pipe(
      switchMap((item) => {
        if (item || !checkFiltered) return of(item)
        // checks for item in filtered list if item not found in main list
        return this.store.select(ItemsSelectors.selectFilteredItemById(id))
      }),
    )
  donationItems$ = this.store.select(ItemsSelectors.selectDonationItems)
  hasDonationItems$ = this.store.select(ItemsSelectors.hasDonationItems)

  constructor(private store: Store<ItemState>) {}

  loadItems(filters: Params = {}): void {
    const action: Action = ObjectUtils.isEmpty(filters)
      ? ItemActions.loadItems()
      : ItemActions.loadFilteredItems({ filters })

    this.store.dispatch(action)
  }

  resyncItems(offset: number, filters: Params = {}, onFocus: boolean = false): void {
    const action: Action = ObjectUtils.isEmpty(filters)
      ? ItemActions.resyncItems(offset, onFocus)
      : ItemActions.resyncFilteredItems(offset, filters, onFocus)

    this.store.dispatch(action)
  }

  resyncItemsFirstPage(filters: Params = {}): void {
    const action: Action = ObjectUtils.isEmpty(filters)
      ? ItemActions.resyncItemsFirstPage()
      : ItemActions.resyncFilteredItemsFirstPage()

    this.store.dispatch(action)
  }

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
